import { Label, PrimaryButton } from "@fluentui/react";
import React from "react";
import { IListaActividadesPorProceso } from "../../../Interfaces/LineaBase/IProcesos";
import { PlantillaPreViewActividades } from "./PlantillaPreViewActividades";

interface IPlantillaVistaActividadesByProceso {
  procesoNombre: string;
  data: IListaActividadesPorProceso[];
}

export const PlantillaVistaActividadesByProceso = (
  props: IPlantillaVistaActividadesByProceso
) => {
  return (
    <>
      <div className="ms-Grid" dir="ltr">
        <div
          className="ms-Grid-row"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "end",
          }}
        >
          <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg12">
            <Label>Proceso: {props.procesoNombre}</Label>
          </div>
        </div>

        <div className="ms-Grid-row">
          <div
            className="ms-Grid-col ms-sm12 ms-md6 ms-lg12"
            style={{
              height: "800px",
              paddingTop: "20px",
              overflowY: "scroll",
            }}
          >
            {props.data?.map((item, i) => (
              <PlantillaPreViewActividades data={item} indice={i} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
